import { Component, OnInit, Inject, HostListener, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PostMessageService } from '../../services/post-message.service';
import { FifaSubscrieService } from '../../services/fifaSubscrie.service';
import { environment } from '../../environments/environment';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout'; // Import BreakpointObserver and Breakpoints
import { HeaderComponent } from '../header/header.component';

declare var bootstrap: any; // Import Bootstrap's JS modal functionality

@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit, AfterViewInit {
  @ViewChild('header') header: HeaderComponent;

  windowScrolled: boolean;
  modalShown: boolean = false; // Prevent showing the modal multiple times
  isMapsPage = false;
  showChatbotWidget = false;
  chatbotBaseURL: SafeResourceUrl;
  showChatbotMessage = true;
  isFullScreen = false;
  showChatbotTopIcon = false;
  showChatMessageContent = true;

  constructor(
    @Inject(DomSanitizer) private document: Document,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private postMessageService: PostMessageService,
    private FifaSubscrieService: FifaSubscrieService,
    private sanitizer: DomSanitizer,
    private breakpointObserver: BreakpointObserver // Inject BreakpointObserver
  ) {
    this.chatbotBaseURL = this.sanitizeUrl(environment.chatbotBaseURL);
    setTimeout(() => {
      this.showChatbotTopIcon = true;
    }, 1000);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) {
      this.windowScrolled = true;
      //showScrollModal added for new lightbox
      if (this.router.url === '/home') {
        this.showScrollModal();
      }
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }

  ngOnInit() {
    this.resizeIframe();
    this.checkMapsPage();
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.checkMapsPage();
      }
    });
    const closed = sessionStorage.getItem('chatClosed');
    this.showChatbotMessage = closed !== 'true'; // show if not already closed
  }

  scrollToTop() {
    (function smoothscroll() {
      var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothscroll);
        window.scrollTo(0, currentScroll - currentScroll / 8);
      }
    })();
  }

  openChat() {
    this.applyNoScrollClass(); // Apply no-scroll class
    this.showChatbotWidget = true;
  }

  closeChatMessage() {
    this.showChatbotMessage = false;
    sessionStorage.setItem('chatClosed', 'true'); // remember that user closed it
  }

  checkMapsPage() {
    if (
      window.location.href.indexOf('app-googlemaps') > -1 ||
      window.location.href.indexOf('explore-seychelles') > -1
    ) {
      this.isMapsPage = true;
    } else {
      this.isMapsPage = false;
    }
  }

  resizeIframe() {
    this.postMessageService.getMessage().subscribe((message) => {
      if (message.maximize) {
        this.toggleIframeClass(true);
        this.setIframeDimensions('100%', '100%');
        this.isFullScreen = true;
      }
      if (message.minimize) {
        const isMobile = this.breakpointObserver.isMatched(Breakpoints.Handset);
        if (isMobile) {
          this.setIframeDimensions('100%', 'calc(100% - 100px)'); // Mobile dimensions
        } else {
          this.setIframeDimensions('400px', 'calc(100% - 200px)'); // Default dimensions
        }
        this.toggleIframeClass(false);
        this.isFullScreen = false;
      }
      if (message.close) {
        this.isFullScreen = false;
        this.showChatbotWidget = false;
        this.removeNoScrollClass(); // Remove no-scroll class
        this.showChatbotMessage = false;
      }
    });
  }

  setIframeDimensions(width: string, height: string): void {
    const iframe = document.getElementById('chatbotIframe') as HTMLIFrameElement;
    if (iframe) {
      iframe.style.width = width;
      iframe.style.height = height;
    }
  }

  toggleIframeClass(expand: boolean) {
    const iframe = document.getElementById('chatbotIframe');
    if (iframe) {
      if (expand) {
        iframe.classList.remove('chatbotFrame');
        iframe.classList.add('expanded');
      } else {
        iframe.classList.add('chatbotFrame');
        iframe.classList.remove('expanded');
      }
    }
  }

  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  // Method to apply no-scroll class
  applyNoScrollClass() {
    document.body.classList.add('no-scroll');
  }
  // Method to remove no-scroll class
  removeNoScrollClass() {
    document.body.classList.remove('no-scroll');
  }

  // ADDED FOR NEW LIGHTBOX START

  // call showEmailSubscribeDialog from shell component
  showEmailSubscribeDialog() {
    this.FifaSubscrieService.showEmailSubscribeDialog();
  }

  // Method to show the Subscribe modal when the user scrolls
  showScrollModal() {
    // Check if the modal has already been shown in this session
    if (!this.modalShown && !sessionStorage.getItem('modalShown')) {
      const modalElement = document.getElementById('scrollModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
        this.modalShown = true; // Prevent reopening
        sessionStorage.setItem('modalShown', 'true'); // Set the session storage item
      }
    }
  }

  // Close the modal manually
  closeModal() {
    const modalElement = document.getElementById('scrollModal');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.hide();
    }
  }
  //ADDED FOR NEW LIGHTBOX END

  ngAfterViewInit() {
    this.cdr.detectChanges();
  }
}
